import { Component, Input, OnInit } from '@angular/core';
import { SocketService } from 'app/core/socket.service';
import { ModalService } from 'app/shared/modal.service';
import { GamesService } from 'app/core/games.service';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-latest-bets',
  templateUrl: './latest-bets.template.html',
  styleUrls: ['./latest-bets.styles.scss'],
  animations: [
    trigger('items', [
      transition(':enter', [
        style({
          height: 0,
          opacity: 0,
          marginBottom: 0,
        }),
        animate(
          '0.3s linear',
          style({
            height: '*',
            opacity: 1,
            marginBottom: '*',
          })
        ),
      ]),
    ]),
  ],
})
export class LatestBetsComponent implements OnInit {
  from: Date = null;
  to: Date = null;
  logs: any = [];
  types: Array<string> = ['all', 'high', 'my'];
  type: string = null;

  @Input() rows: number = 6;

  constructor(private socket: SocketService, public service: GamesService, private modalService: ModalService) {}

  ngOnInit() {
    this.type = this.types[0];
    this.getLogs(this.type);
    this.listenForLog();
  }

  private getLogs(type: string) {
    this.service
      .getLogs(type, this.rows)
      .then(data => {
        this.logs = data;
      })
      .catch(() => {});
  }

  public listenForLog() {
    this.socket.listen('/', 'new-game-result').subscribe(data => {
      this.logs.unshift(data);
      if (this.logs.length > this.rows) {
        this.logs.pop();
      }
    });
  }

  public show(item: any) {
    this.modalService.openFairnessResult(item);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/shared/leaderboard-bets-wrapper/latest-bets/latest-bets.component.ts